import { useDispatch, useSelector } from "react-redux";
import ContentList from "../../App/screens/ContentPage/list";
import { CONTENT_GROUP_ACTION } from "../../constants";
import { content_groupActions } from "../../actions";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { comment } from "../../reducers/comment.reducer";

function UniversalCardPopup(props){
    const {
        isOpen,
        data,
        highlighted_comment
    } = useSelector(state => state.card_popup_modal);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch({ type: CONTENT_GROUP_ACTION.CLOSE_CARD_MODAL });
        dispatch({ type: CONTENT_GROUP_ACTION.UNSET_HIGHLIGHTED_COMMENT });
    }

    const handleInlineEdit = (handleOnBlur, values, content_group_id, setIsDisabled) => {
        const content_popup_notification = false;
        dispatch(content_groupActions.inlineEditContentGroup(handleOnBlur, values, content_group_id, data?.workspace_id, content_popup_notification, setIsDisabled));
        dispatch(content_groupActions.replaceContentImageLazeLoading(data?.workspace_id, [content_group_id]));
    }

    if (!isOpen || !data) {
        return null;
    }
    
    return (
        <ContentList
            content_group_id={data?.id}
            workspace_id={data?.workspace_id}
            handleCloseContentGroupPopUp={handleClose}
            handleInlineEdit={handleInlineEdit}
            highlighted_comment={highlighted_comment}
        />
    );
};

export { UniversalCardPopup };